import React, { useState, useEffect, useRef } from "react";
import Steps from "./Steps";

function CompanyDetailsForm3({ setFormNum, setFormData, formData }) {
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Prime Category*");
  const [isCategoryDropdownVisible, setIsCategoryDropdownVisible] =
    useState(false);
  const [fileName, setFileName] = useState(null);
  const categoryDropdownRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      setFormData((prevState) => ({ ...prevState, banner_image: file }));
    }
  };

  const handleRemoveFile = (e) => {
    e.preventDefault(); // Prevent form submission
    setFileName(null);
    setFormData((prevState) => {
      const newState = { ...prevState };
      delete newState.banner_image;
      return newState;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      selectedCategory === "Prime Category*" &&
      formData.prime_category === ""
    ) {
      console.log(formData.prime_category);
      alert("Select a prime category");
      return;
    }
    // console.log(formData);
    console.log("submitted");
    setFormNum((prev) => prev + 1);
  };

  const toggleCategoryDropdown = () =>
    setIsCategoryDropdownVisible(!isCategoryDropdownVisible);
  const handleCategorySelect = (category_name) => {
    setSelectedCategory(category_name);
    setFormData((prevState) => ({
      ...prevState,
      prime_category: category_name,
    }));
    setIsCategoryDropdownVisible(false);
  };

  const handleBackClick = () => {
    setFormNum((prev) => prev - 1);
  };

  async function fetchCountryData() {
    try {
      const response = await fetch(
        "/api/get_sub_category.php",
        {
          method: "GET",
        }
      );

      const text = await response.text();
      // console.log('Raw response:', text);

      const cleanedText = text.replace(/[^{}[\],:\"\s0-9a-zA-Z]/g, "");
      // console.log('Cleaned response:', cleanedText);

      const parts = cleanedText.split("}{");
      // console.log('Split parts:', parts);

      const jsonParts = parts.map((part, index) => {
        if (index === 0) return part + "}";
        if (index === parts.length - 1) return "{" + part;
        return "{" + part + "}";
      });
      // console.log('JSON formatted parts:', jsonParts);

      try {
        const categoryData = JSON.parse(jsonParts[0]);
        const countryData = JSON.parse(jsonParts[1]);
        const responseCountData = JSON.parse(jsonParts[2]);

        // console.log('Parsed response count data:', responseCountData);

        // Handle category data
        if (categoryData.category && Array.isArray(categoryData.category)) {
          setCategoryData(categoryData.category);
        }
      } catch (parseError) {
        console.error("Error parsing JSON parts:", parseError);
        setCategoryData([]);
      }
    } catch (e) {
      console.error("Error fetching or processing the response:", e);
      setCategoryData([]);
    }
  }

  useEffect(() => {
    fetchCountryData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target)
      ) {
        setIsCategoryDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="flex justify-center items-center font-inter">
      <div className="w-full max-w-lg xl:max-w-4xl bg-white p-4 sm:px-0">
        <div>
          <Steps stepNum={3} setFormNum={setFormNum} />
          <h2 className="text-xl md:text-2xl 2xl:text-3xl 2xl:mb-4 2xl:ml-1 font-semibold text-[#111827] mb-2">
            Select Business Category
          </h2>
        </div>
        <div ref={categoryDropdownRef} className="w-full mb-4">
          <button
            onClick={toggleCategoryDropdown}
            className="w-full px-4 py-2 2xl:py-3 2xl:text-lg border border-[#CAD0D9] text-[#5F5F5F] rounded-lg bg-white text-left"
          >
            <span
              className={`truncate xl:ml-1 2xl:text-lg
                ${
                  formData.prime_category && formData.prime_category.length > 0
                    ? "text-[#5F5F5F]"
                    : selectedCategory === "Prime Category*"
                    ? "text-[#9CA3AF]"
                    : "text-black"
                }  `}
            >
              {formData.prime_category || selectedCategory}
            </span>
          </button>

          {isCategoryDropdownVisible && (
            <div className="relative">
              <ul className="absolute z-10 w-full bg-white border border-gray-300 rounded-lg shadow-md max-h-50 overflow-y-auto">
                {categoryData.map((category, index) => (
                  <li
                    key={index}
                    onClick={() => handleCategorySelect(category.catname)}
                    className="text-[#5F5F5F] px-5 py-1 text-sm lg:text-sm 2xl:text-base hover:bg-gray-100 hover:text-black cursor-pointer  border b-2"
                  >
                    {category.catname}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className="w-full mb-2">
          <input
            type="text"
            id="secondary-category"
            className="w-full text-[#5F5F5F] px-4 py-2 2xl:py-3 2xl:text-lg border border-[#CAD0D9] rounded-lg"
            placeholder="Secondary Category"
            name="secondary_category"
            value={formData.secondary_category}
            onChange={handleChange}
          />
        </div>
        <div>
          <h2 className="text-xl md:text-2xl 2xl:text-3xl 2xl:my-6 2xl:ml-1 font-semibold text-[#111827]">
            Banner Image
          </h2>
        </div>
        <div className="flex items-center gap-2 mb-2">
          <label
            htmlFor="banner_image"
            className="w-full flex items-center px-4 py-2 2xl:py-3 border border-[#CAD0D9] rounded-lg cursor-pointer"
          >
            <span className="flex-grow text-[#9CA3AF]">
              {formData.banner_image && formData.banner_image.name
                ? formData.banner_image.name
                : "Thumbnail Banner Image"}
            </span>
            <input
              type="file"
              id="banner_image"
              className="hidden"
              name="banner_image"
              accept="image/*"
              onChange={handleFileChange}
            />
          </label>
          {fileName && (
              <button
                onClick={handleRemoveFile}
                className="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                X
              </button>
            )}
        </div>

        <p className="text-sm text-[#5F5F5F] text-left py-0 2xl:py-3 2xl:text-md mb-4">
          Image size should be 820x312 px. The file should be in jpg, jpeg, or png format with a maximum size of 2MB.
        </p>

        <div className="flex justify-between gap-4">
          <button
            className="w-full px-4 py-2 text-white 2xl:py-3 bg-[#5D5D5D] rounded-lg hover:bg-[#4B4B4B] transition-colors"
            type="button"
            onClick={handleBackClick}
          >
            Back
          </button>

          <button
            className="w-full px-4 py-2 text-white 2xl:py-3 bg-[#5D5D5D] rounded-lg hover:bg-[#4B4B4B] transition-colors"
            type="button"
            onClick={handleSubmit}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompanyDetailsForm3;